// extracted by mini-css-extract-plugin
module.exports = {"scorecard-category-list":"styles-module__scorecard-category-list___22s3t"};